import { useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Modal, message } from "antd";
import { useTranslation } from "react-i18next";
import { ROUTES } from "../../routes/patientRoutes/routePaths";
import { isValidEmail } from "../functions/validators/isValidEmail";
import { requestPasswordReset } from "../redux/thunks/authThunks";

export default function usePatientForgotPassword() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSendCode = useCallback(async () => {
    if (!isValidEmail(email)) {
      setError(t("auth.forgotInvalidEmail"));
      return;
    }
    setError("");
    setLoading(true);
    try {
      await dispatch(requestPasswordReset(email.trim())).unwrap();
      message.success(t("auth.forgotCodeSent"));
      navigate(ROUTES.VERIFY_CODE, { state: { email: email.trim() } });
    } catch (err) {
      const msg =
        typeof err === "string"
          ? err
          : err?.message || t("auth.forgotSendFailed");
      setError(msg);
      Modal.error({ title: t("auth.forgotSendFailedTitle"), content: msg });
    } finally {
      setLoading(false);
    }
  }, [dispatch, email, navigate, t]);

  const onKeyDown = useCallback(
    (e) => {
      if (e.key === "Enter" && !loading) handleSendCode();
    },
    [handleSendCode, loading]
  );

  const goLogin = useCallback(() => navigate(ROUTES.LOGIN), [navigate]);

  return {
    email,
    error,
    loading,
    setEmail,
    setError,
    handleSendCode,
    onKeyDown,
    goLogin,
  };
}
